// @file For scripts on tldraw canvas
import { useSurfaceStore } from '@@/pinia/surface'
import PadletApi from '@@/surface/padlet_api'
import type { BlocklyScriptBlocks } from '@@/types/whiteboard'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useWhiteboardScriptStore = defineStore('whiteboardScript', () => {
  const surfaceStore = useSurfaceStore()
  const scripts = ref<Record<string, BlocklyScriptBlocks>>({})

  async function initializeWhiteboardScripts(): Promise<void> {
    const listOfScripts = await PadletApi.WhiteboardScript.fetch(surfaceStore.wallId as number)
    const scriptsObject = {}
    listOfScripts.forEach((script) => {
      scriptsObject[script.shapeId] = script.script
    })
    scripts.value = scriptsObject
  }

  async function upsertScript(shapeId: string, script: BlocklyScriptBlocks): Promise<void> {
    scripts.value[shapeId] = script
    await PadletApi.WhiteboardScript.upsert(surfaceStore.wallId as number, shapeId, script)
  }

  function checkIfScriptExists(shapeId: string): boolean {
    return scripts.value[shapeId] != null
  }

  return {
    // State
    scripts,
    // Actions
    initializeWhiteboardScripts,
    upsertScript,
    checkIfScriptExists,
  }
})
